export default __webpack_public_path__ + "d6c7d92b3708c25d10acdb61849042b9.jpg";